<template>
  <nav class="nav">
    <div class="nav-top-wrapper">
      <div class="nav-links">
        <div class="left">
          <FullLogo @click="mobileVisible = false"></FullLogo>
          <TextButton @click="redirectFaq">FAQ</TextButton>
          <TextButton @click="redirectContact">Contact Us</TextButton>
        </div>
        <div v-if="isInDashboard" class="right">
          <P v-if="userName">{{ userName.name }}</P>
          <Button class="red" @click="logout">Logout</Button>
        </div>
      </div>
      <div class="nav-dropdown-wrapper">
        <button
          class="nav-hamburger"
          @click="toggleMobileVisibility"
          :class="{ open: mobileVisible }"
          ref="hamburger"
        >
          <font-awesome-icon v-if="mobileVisible" :icon="['fal', 'times']" />
          <font-awesome-icon v-else :icon="['fal', 'bars']" />
        </button>
      </div>
    </div>
    <div
      class="nav-mobile"
      :style="{ transform: `translateY(${navHeight}px)` }"
      :class="{ 'nav-mobile-visible': mobileVisible }"
      ref="navMobile"
    >

      <div class="nav-mobile-links">
        <div
          class="nav-mobile-link-wrapper"
        >
          <Link
            to="/faq"
            @click.native="closeUserDrop"
          >
            <div class="nav-mobile-link">FAQ</div>
          </Link>
        </div>
        <div
          class="nav-mobile-link-wrapper"
        >
          <Link
            to="/contact"
            @click.native="closeUserDrop"
          >
            <div class="nav-mobile-link">Contact Us</div>
          </Link>
        </div>
        <div
          v-if="isLoggedIn"
          class="nav-mobile-link-wrapper"
        >
          <Link
            to="/contact"
            @click.native="logout"
          >
            <div class="nav-mobile-link">Logout</div>
          </Link>
        </div>
      </div>
    </div>
    <div
      class="screen-overlay"
      v-if="mobileVisible"
      @click="toggleUserDropdownVisibility"
    ></div>
  </nav>
</template>

<script>
import FullLogo from "./FullLogo";
import { Button, TextButton, P, Link } from "../style";
import { mapState, mapMutations } from "vuex";
import { LOGOUT, SET_NAV_HEIGHT } from "../store/types";
export default {
  name: "Nav",
  components: {
    FullLogo,
    Button,
    TextButton,
    P,
    Link
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn,
      userLoggedIn: (state) => state.auth.user,
      navHeight: (state) => state.navheight.height,
    }),
    isInDashboard() {
      return this.isLoggedIn && this.$route.name == "dashboard";
    },
    userName() {
      return this.userLoggedIn;
    }
  },
  data() {
    return {
      mobileVisible: false,
      userDropdownVisible: false,
    }
  },
  methods: {
    ...mapMutations({
      setLogout: LOGOUT,
      setNavHeight: SET_NAV_HEIGHT
    }),
    logout() {
      this.setLogout();
      this.$router.push("/login").catch(() => {});
    },
    redirectFaq() {
      this.$router.push("/faq").catch(() => {});
    },
    redirectContact() {
      this.$router.push("/contact").catch(() => {});
    },
    toggleUserDropdownVisibility() {
      this.userDropdownVisible = !this.userDropdownVisible;
      this.mobileVisible = false;
    },
    toggleMobileVisibility() {
      this.mobileVisible = !this.mobileVisible;
      this.userDropdownVisible = false;
    },
    fixedBody() {
      if (this.mobileVisible) {
        this.body.style.overflow = "hidden";
      } else {
        this.body.style.overflow = "auto";
      }
    },
    hideAndShowNav() {
      var currentScrollPos = window.pageYOffset;
      this.locked = currentScrollPos <= 0;
      if (
        currentScrollPos < this.navHeight + 5 ||
        this.prevScrollpos > currentScrollPos
      ) {
        this.hideNav = false;
        this.userDropdownVisible = false;
        this.notifDropdownVisible = false;
      } else {
        this.hideNav = true;
        this.mobileVisible = false;
      }
      this.prevScrollpos = currentScrollPos;
    },
    resizeScreen() {
      const { hamburger, nav } = this.$refs;
      this.setNavHeight(nav.clientHeight);
      if (this.isLoggedIn) {
        const mobileMenuIcon = window.getComputedStyle(hamburger);
        if (mobileMenuIcon.display === "none") {
          this.mobileVisible = false;
        } else {
          this.userDropdownVisible = false;
          this.notifDropdownVisible = false;
        }
      }
    },
    closeUserDrop() {
      this.mobileVisible = false;
      this.userDropdownVisible = false;
      this.notifDropdownVisible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.nav {
  background-color: $white;
  display: flex;
  align-items: center;
  width: 100%;
  position: fixed;
  top: 0;
  transform: translateY(0px);
  transition: $transition-simple-fast;
  z-index: 500;
  box-shadow: none;
  transition-property: transform, box-shadow;
  height: 3.875rem;
  padding: 0 $padding-lg;
  align-content: space-between;
  justify-content: space-between;
  @include breakpoint(mobile-hd-width) {
    padding: 0 $padding-xxl;
  }
  &-top-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
  }
  @media (max-width: $mobile-hd-width) {
    .text-button {
      display: none;
    }
  }
  @media (min-width: $mobile-hd-width) {
    .nav-links {
      display: flex;
      width: 100%;
      .left {
        justify-content: flex-start;
        width: 100%;
      }
      .right {
        justify-content: flex-end;
        width: 100%;
      }
    }
    .nav-dropdown-wrapper {
      display: none;
    }
    .screen-overlay {
      display: none;
    }
  }
  .left {
    display: flex;
    align-items: center;
    button {
      margin-left: $padding-xxl;
      font-weight: 400;
      letter-spacing: normal;
    }
  }
  .right {
    display: flex;
    align-items: center;
    button {
      margin-left: $padding-lg;
    }
  }
  .right {
    display: flex;
    align-items: center;
    button {
      margin-left: $padding-lg;
    }
  }
  .red {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  &-dropdown-wrapper {
    height: 100%;
    margin-left: auto;
    display: flex;
    align-items: center;
    button {
      width: 100%;
      border: none;
      background-color: transparent;
      cursor: pointer;
      text-align: left;
      padding: $padding-lg $padding-700;
      height: 100%;
      position: relative;
      &:focus {
        outline: none;
        background-color: $blue-gray-light;
        color: $red-active;
        stroke: $red-active;
        transition: $transition-simple-xtra-fast;
      }
    }
  }
  button.nav-hamburger {
    width: 30px;
    height: 30px;
    padding: 0;
    border-radius: $border-radius-md;
    font-size: 1.5rem;
    text-align: center;
    color: $red-active;
    margin-left: $padding-lg;
  }
  &-hamburger {
    cursor: pointer;
    color: $red-dark;
    stroke: $red-dark;
    transition: $transition-simple-fast;
    &:focus {
      background-color: $white;
    }
    svg {
      align-items: center;
      display: flex;
      margin: auto;
    }
    &.open {
      width: 30px;
      height: 30px;
      transition: 0.25s ease-in;
    }
  }
  &-mobile {
    display: none;
    &-links {
      border-bottom: 1px solid $background-dark;
      &.router-link-exact-active {
        color: $blue-active;
      }
    }
    &-link,
    &-user-link {
      padding: 0.75rem $padding-xl;
    }
    .nav-user-link-wrapper button {
      padding: 0.75rem $padding-xl;
    }
    &-user {
      &-path {
        .nav-user-button {
          &::before {
            content: "";
            position: absolute;
            width: 3px;
            height: 100%;
            top: 0;
            left: 0;
            background-color: $red-active;
            transform: scaleX(0);
            transform-origin: left;
            transition: $transition-simple-xtra-fast;
          }
          &:focus {
            outline: none;
            background-color: $red-xtra-light;
            color: $red-active;
            stroke: $red-active;
            h4 {
              color: $red-active;
            }
          }
          &:hover {
            background-color: $red-xtra-light;
          }
        }
        &.router-link-exact-active {
          .nav-user-button {
            background-color: $red-xtra-light;
            color: $red-active;
            &::before {
              transform: scaleX(1);
            }
            &:focus {
              background-color: $red-xtra-light;
            }
          }
        }
      }
    }
    &.nav-mobile-visible {
      position: fixed;
      top: -0.8rem;
      right: 0;
      height: calc(100vh - 62px);
      width: 100%;
      padding-top: 2px;
      overflow-y: scroll;
      max-width: 80%;
      display: flex;
      flex-direction: column;
      background-color: $white;
      z-index: 11;
      cursor: pointer;
      .nav-mobile-links,
      .nav-mobile-user-links {
        a.router-link-exact-active {
          &:before {
            transform: scaleX(1);
          }
          .nav-mobile-link,
          .nav-mobile-user-link {
            color: $red-active;
            background-color: $red-xtra-light;
          }
          &:focus {
            .nav-mobile-link,
            .nav-mobile-user-link {
              color: $red-active;
              background-color: $red-xtra-light;
            }
          }
        }
      }
    }
    &-link-wrapper {
      a {
        color: $blue-navy;
        text-decoration: none;
      }
    }
  }
}
.screen-overlay {
  position: fixed;
  top: 64px;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: $black;
  opacity: 0.75;
  z-index: 10;
  cursor: pointer;
}
</style>